import ScrollReveal from 'scrollreveal';

window.sr = ScrollReveal();

sr.debug = true;

const reveal = (className) => {
  const itemsDOM = document.querySelectorAll(className);

  itemsDOM.forEach(item => {
    const delay = item.getAttribute('data-delay');
    const duration = item.getAttribute('data-duration');
    const type = item.getAttribute('data-type');

    let slideObj = {
      distance: '25%',
      origin: 'bottom',
      opacity: 0,
      easing: 'ease-in-out',
      duration: 800,
      viewFactor: 0.15,
      delay: 250,
    };

    if (duration != null) {
      slideObj.duration = duration;
    }
    if (delay != null) {
      slideObj.delay = delay;
    }

    switch (type) {
      case 'bottom':
        slideObj.origin = 'top';
        break;
      case 'left':
        slideObj.origin = 'left';
        break;
      case 'right':
        slideObj.origin = 'right';
        break;
      default:
        slideObj.origin = 'bottom';
    }

    sr.reveal(item, slideObj);
  })
}

export default reveal